import React from 'react'
import clsx from 'clsx'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import Popover from '@mui/material/Popover'
import AttachFileIcon from '@mui/icons-material/AttachFile'
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile'

import {contentLink, viewerGuard} from 'helpers/url'

const useStyles = makeStyles(homeworkBodyStyles)

export default function HomeworkFiles({passport, files = []}) {

  const classes = useStyles()
  const [anchorEl, setAnchorEl] = React.useState(null)
  const handleViewFilesClick = (event) => {
    if(!files.length) return
    setAnchorEl(event.currentTarget)
  };
  const handleClose = () => { setAnchorEl(null)  }
  const openPopOver = Boolean(anchorEl);
  const id = openPopOver ? 'popover' : undefined;
  
  return (
    <>
        <span 
            onClick={(e)=> { handleViewFilesClick(e) }} 
            className={clsx(classes.attachedFiles, )}
            >
            <AttachFileIcon className={clsx(classes.attachedFiles, {disabled: files.length == 0})} />
        </span>      
        
        <Popover
          id={id}
          open={openPopOver}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <Box className={classes.fileDownload}>
            {files.map((f, i)=> {
              return (
                <div key={i}>
                  <InsertDriveFileIcon />
                  <a {...viewerGuard({href: contentLink(passport, f.folder, f.name), target: "_blank"})}>{f.name}</a>
                </div>)
            })}            
          </Box>          
        </Popover>
    </>
  )
}

function homeworkBodyStyles() {
    return {       
        statusIndicator: {
            '&.available': {
                backgroundColor: 'orange',
                borderRadius: '100%',
                width: 15,
                height: 15,
                display: 'inline-block',
                marginRight: 10
            }
        },
        title: {          
          cursor: 'pointer',
          width: '30%',
          '&:hover': {
            color: '#127e7e',
            textDecoration: 'underline'
          }
          
        },
        statusName: {
          padding: '5px',
          color: '#fff',
          borderRadius: '20px',
          display: 'inline-block',
          width: 100,
          textAlign: 'center',
          '&.assigned': {
            backgroundColor: '#f78d43'
          },
          '&.completed': {
            backgroundColor: '#06b71c'
          },
          '&.pending': {
            backgroundColor: '#0ac7ff'
          },
          '&.returned': {
            backgroundColor: '#ff0a0a'
          }
          
        },
        scoreField: {
          fontSize: '14pt',
          fontWeight: 'bold'
        },
        scoreTextBox: {
          width: 70,
          height: 30,
          border: '1px solid #ccc',
          marginRight: 15,
          textAlign: 'center',
          padding: '0 5px',
          borderRadious: 4
        },
        visuallyHidden: {
          border: 0,
          clip: 'rect(0 0 0 0)',
          height: 1,
          margin: -1,
          overflow: 'hidden',
          padding: 0,
          position: 'absolute',
          top: 20,
          width: 1,
        },
        personIcon: {
          color: '#128080',
          position: 'relative',
          top: 6
        },
        link: {
          color: '#009dd8',
          fontSize: '16pt',
          marginRight: 20,
          cursor: 'pointer'
        },
        attachedFiles: {
          color: '#009dd',
          cursor: 'pointer',
          '&.disabled': {
            fill: '#ccc',
            cursor: 'default'
          },
          '& > svg': {
            fill: "#009dd8"
          }
        },
        fileDownload: {
          padding: 25,
          '& > div': {
            borderBottom: '1px dotted #ccc',
            padding: '10px 0'
          },
          '& > div:last-child': {
            borderBottom: 'none'
          },
          '& > div > svg': {
            fill: '#ccc',
            height: 20
          },
          '& > div > a': {
            position: 'relative',
            top: -3,
            color: '#009dd8',
            textDecoration: 'none',
            '&:hover': {
              textDecoration: 'underline',
            }
          }
        },
        feedbackBox: {
          display: 'block',
          margin: '10px 0',
          backgroundColor: '#e8e8e8',
          padding: 5,
          borderRadius: 3,
          '& label': {
            fontSize: '12px'
          }
        },
        feedbackText: {
          fontSize: '12px',
          fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
          padding: 10,
          borderRadius: 4,
          border: '1px solid #ccc',
          width: '100%'
        }
      };
}
